<!-- 手机号 -->
<template>
    <el-popover ref="popoverRef" :virtual-ref="triggerRef" virtual-triggering trigger="click" placement="bottom"
        :width="200" :show-after="0" :hide-after="0" @before-enter="show">
        <el-input v-model="state.value" :placeholder="state.placeholder" @keyup.enter="handleSearch(2)" />
        <div class="btn-box">
            <el-button size="small" @click="handleSearch(1)">重置</el-button>
            <el-button type="primary" size="small" @click="handleSearch(2)">筛选</el-button>
        </div>
    </el-popover>
</template>
<script setup>
import { reactive, ref } from 'vue';
const props = defineProps({
    field: {
        type: String,
        default: () => ''
    },
    triggerRef: {
        type: Object,
        default: () => { }
    },
    formValue: {
        type: Object,
        default: () => { }
    },
    placeholder: {
        type: String,
        default: () => '请输入'
    },
});
const emit = defineEmits(['handleSearch'])
const popoverRef = ref();
const state = reactive({
    value: props.formValue[props.field],
    placeholder: props.placeholder
});
const handleSearch = (type) => {
    if (type == 1) {
        // 重置
        state.value = '';
    }
    props.formValue[props.field] = state.value;
    popoverRef.value.hide();
    emit('handleSearch');
}
const show = () => {
    state.value = props.formValue[props.field];
}
</script>
<style lang="scss" scoped>
.btn-box {
    text-align: right;
    padding-top: 12px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}

::v-deep .el-input-number .el-input__inner {
    text-align: left;
}
</style>